module.exports = __webpack_public_path__ + "img/vessel_visitation_6_63021.2da73637.jpg";